
export const arraySame = (array1: string[], array2: string[]): boolean => array1.filter(i => !array2.includes(i))
    .concat(array2
        .filter(i => !array1.includes(i))).length === 0;
